import React, { useEffect } from "react";
import { Box, Typography, Grid, TextField, MenuItem } from "@mui/material";
import styles from "../InternalTracker/InternalTracker.module.css";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import { fieldStyle, prefer_tax_term } from "../../utils/const2";
import { useDispatch, useSelector } from "react-redux";
import { GoTrash } from "react-icons/go";
import { IoIosSearch } from "react-icons/io";
import { allLocation } from "../../redux/common/locationSlice";
import { BsThreeDotsVertical } from "react-icons/bs";

export default function SearchFilterJob(props) {
  const {
    handleOnClear,
    setSearchData,
    searchData,
    jobTitles,
    handleOnClickSearch,
    selectFilterData,
    handleShow,
  } = props;

  const dispatch = useDispatch();
  const locations = useSelector((state) => state.location.data);

  useEffect(() => {
    dispatch(allLocation());
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        marginBotton: "14px",
      }}
    >
      <Grid container>
        <Grid item xs="12" sm="6" md="2.4" lg="2.4" sx={{ padding: "0 5px" }}>
          <Box sx={{ marginTop: "7px" }}>
            <Typography>job Id</Typography>
            <TextField
              id="outlined-basic"
              type="text"
              variant="outlined"
              size="small"
              placeholder="enter job id"
              sx={{ backgroundColor: "#fff", width: "100%" }}
              name="job_id"
              value={searchData?.job_id || ""}
              onChange={(event) => {
                setSearchData((prev) => ({
                  ...prev,
                  job_id: event.target.value,
                }));
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={2.4} lg={2.4} sx={{ padding: "0 5px" }}>
          <Box sx={{ marginTop: "7px" }}>
            <Typography>Job Profile</Typography>
            <Autocomplete
              multiple
              id="autocomplete-multi-select"
              options={jobTitles || []}
              disableCloseOnSelect
              value={
                jobTitles?.filter((job) =>
                  searchData?.job_title?.includes(job)
                ) || []
              }
              onChange={(event, value) => {
                const selectedJobIds = value?.map((job) => job);
                setSearchData((prev) => ({
                  ...prev,
                  job_title: selectedJobIds, // Update job_profile array in searchData
                }));
              }}
              getOptionLabel={(option) => option || ""}
              renderOption={(props, option, { selected }) => (
                <MenuItem {...props}>
                  <Checkbox
                    checked={selected}
                    sx={{ marginRight: 0, marginLeft: 0 }}
                  />
                  <span>{option}</span>
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  name="job_title"
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                  placeholder="Select job profile"
                />
              )}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            />
          </Box>
        </Grid>

        <Grid item xs="12" sm="6" md="2.4" lg="2.4" sx={{ padding: "0 5px" }}>
          <Box sx={{ marginTop: "7px" }}>
            <Typography>Mode of Hiring </Typography>
            <Autocomplete
              multiple
              id="autocomplete-multi-select"
              options={prefer_tax_term || []}
              disableCloseOnSelect
              value={
                (prefer_tax_term?.length > 0 &&
                  prefer_tax_term?.filter((skl) =>
                    searchData?.requirement_type?.includes(skl.value)
                  )) ||
                []
              }
              onChange={(event, value) => {
                // Update the `searchData` state when skills are selected
                const selectedSkillIds = value?.map((skl) => skl?.value);
                setSearchData((prev) => ({
                  ...prev,
                  requirement_type: selectedSkillIds, // Update the skills array in searchData
                }));
              }}
              getOptionLabel={(option) => option?.label || ""}
              renderOption={(props, option, { selected }) => (
                <MenuItem {...props}>
                  <Checkbox
                    checked={selected}
                    sx={{ marginRight: 0, marginLeft: 0 }}
                  />
                  <span>{option?.label}</span>
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Visa"
                  variant="outlined"
                  size="small"
                  name="requirement_type"
                  sx={fieldStyle}
                  placeholder="Select hiring mode"
                />
              )}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            />
          </Box>
        </Grid>

        <Grid item xs="12" sm="6" md="2.4" lg="2.4" sx={{ padding: "0 5px" }}>
          <Box sx={{ marginTop: "7px" }}>
            <Typography>Location</Typography>
            <Autocomplete
              multiple
              id="autocomplete-multi-select"
              options={locations?.locations || []}
              disableCloseOnSelect
              value={
                locations?.locations?.filter((skl) =>
                  searchData?.location?.includes(skl.id)
                ) || []
              }
              onChange={(event, value) => {
                // Update the `searchData` state when skills are selected
                const selectedLocationId = value?.map((skl) => skl?.id);
                setSearchData((prev) => ({
                  ...prev,
                  location: selectedLocationId, // Update the skills array in searchData
                }));
              }}
              getOptionLabel={(option) => option?.name || ""}
              renderOption={(props, option, { selected }) => (
                <MenuItem {...props}>
                  <Checkbox
                    checked={selected}
                    sx={{ marginRight: 0, marginLeft: 0 }}
                  />
                  <span>{option?.name}</span>
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Location"
                  variant="outlined"
                  size="small"
                  name="skills"
                  sx={fieldStyle}
                  placeholder="Select Location"
                />
              )}
              sx={{
                backgroundColor: "#fff",
                width: "100%",
                paddingBottom: "10px",
              }}
            />
          </Box>
        </Grid>

        <Grid
          item
          xs="12"
          sm="6"
          md="2.4"
          lg="2.4"
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>
              {selectFilterData?.length} Profile Shortlisted
            </Typography>
            <BsThreeDotsVertical
              style={{
                fontSize: "22px",
                cursor: "pointer",
                marginLeft: "10px",
              }}
              onClick={handleShow}
            />
          </Box>
          <Box
            className={styles.search_btn}
            sx={{ position: "relative", top: "7px" }}
          >
            <button
              variant="contained"
              style={{ backgroundColor: "#0070c0", marginRight: "10px" }}
              onClick={handleOnClickSearch}
            >
              Search <IoIosSearch style={{ fontSize: "17px" }} />
              {/* Search */}
            </button>
            <button
              variant="contained"
              style={{ backgroundColor: "#4285f4" }}
              onClick={handleOnClear}
            >
              <GoTrash style={{ fontSize: "17px" }} />
              {/* Clear */}
            </button>
          </Box>
        </Grid>
      </Grid>
      {/* <SearchSelectedCandiadtesDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={show}
        row={selectFilterData}
        getLocationById={getLocationById}
        toggleSelect={toggleSelect}
      /> */}
    </Box>
  );
}
